<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import Administrador from "./dashboard/administrador";
import Director from "./dashboard/director";
import Usuario from "./dashboard/usuario";

/**
 * Starter component
 */
export default {
  components: { Layout, PageHeader, Administrador, Director, Usuario },
  data() {
    return {
      title: "Starter Page",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ]
    };
  }
};
</script>
<template>
  <Layout>
    <PageHeader  :items="items" />
    <Administrador v-if="user.rol_id==1"/>
    <Director :colegio="user.colegio_id" v-if="user.rol_id==2"/>
    <Usuario v-if="user.rol_id!=1 && user.rol_id!=2"/>
  </Layout>
</template>
